import React from "react";

import { ReactComponent as StackHalfFillIcon } from "../../../assets/images/icons/stack-half-fill.svg";
import { ReactComponent as StackSolidIcon } from "../../../assets/images/icons/stack-solid.svg";

import "./StyledPanelBadge.css";

export default function StyledPanelBadge({
  text,
  textColor,
  backgroundColor,
  context = "browse",
  icon = true,
  panelType = "part_of_panel",
  className = "",
}) {
  if (!text) {
    return null;
  }

  const style = context === "selected"
    ? undefined
    : { color: textColor, backgroundColor };

  const Icon = (context === "selected" && panelType === "part_of_panel")
    ? StackHalfFillIcon
    : StackSolidIcon;

  return (
    <span
      className={`StyledPanelBadge StyledPanelBadge--${context} ${className}`}
      style={style}
    >
      {icon && <Icon className="StyledPanelBadge__Icon" aria-hidden />}
      <span className="StyledPanelBadge__Text">{text}</span>
    </span>
  );
}
